<!--
 * @Description:
 * @Author: luokang
 * @Date: 2023-12-13 16:07:57
-->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$lang('验证身份')"
    top="10vh"
    width="480px"
    @close="close"
    @open="open"
    :visible.sync="visible"
    >
    <main class="verification_code_cont">
      <!-- 验证码验证 -->
      <section v-show="isKey">
        <div class="verification_code_title">
          {{ $lang('为了您的帐号安全，登录前需验证身份。请输入手机验证应用提供的 6位验证码') }}
        </div>
        <label class="verification_code_label">
          <span>*</span>
          <span>{{$lang('验证码')}}</span>
          <span @click="isKey=0">{{$lang('无法获得验证码？')}}</span>
        </label>
        <PhoneNumber style="margin:auto;" v-model="verificationCode" showVal ref="phoneNumber" @upenter='upenter'/>
      </section>
      <!-- 密钥验证 -->
      <section v-show="!isKey">
        <p class="step_error">
          <img src="@/assets/images/codeErr.png" alt="报错提示">
          <span>{{ $lang('如果您的紧急恢复密钥丢失，请联系管理员处理') }}</span>
        </p>
        <label class="verification_code_label">
          <span>*</span>
          <span>{{$lang('紧急恢复密钥')}}</span>
        </label>
        <el-input class="verification_input" v-model="recoveryKey" ref="recoveryKey" :placeholder="`${$lang('例如')} AA00 BB11 CC22 DD33 EE44 FF55`"></el-input>
      </section>
      <el-button class="login_btn" type="primary" v-loading="confirmLoading" @click="confirmHandle">{{$lang('验证身份')}}</el-button>
    </main>
  </el-dialog>
</template>
<script>
import PhoneNumber from '@/components/base/phoneNumberCode.vue'
import * as Api from '@api/base/public'

export default {
  components: {
    PhoneNumber
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    googleInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  name: 'VerificationCodeDialog',
  data() {
    return {
      verificationCode: '',
      recoveryKey: '',
      isKey: 1,
      confirmLoading: false
    }
  },
  computed: {},
  watch: {},
  methods: {
    close() {
      this.isKey = 1
      Object.assign(this.$data, this.$options.data())
      this.$emit('update:visible', false)
    },
    confirmHandle() {
      const codeLogin = async () => {
        this.confirmLoading = true
        const params = {
          account: this.googleInfo.account,
          googleTwoFactorValidateToken: this.googleInfo.googleTwoFactorValidateToken,
          code: this.verificationCode
        }
        const res = await Api.checkGoogleTwoFactor(params)
        this.confirmLoading = false
        if (res.code === 1) {
          this.$emit('success', res)
        } else {
          this.verificationCode = ''
          this.$message.error(res.msg)
        }
      }
      const keyLogin = async () => {
        const params = {
          account: this.googleInfo.account,
          googleTwoFactorValidateToken: this.googleInfo.googleTwoFactorValidateToken,
          code: this.recoveryKey
        }
        const res = await Api.checkGoogleTwoFactor(params)
        this.confirmLoading = false
        if (res.code === 1) {
          this.$emit('success', res)
        } else {
          this.recoveryKey = ''
          this.$message.error(res.msg)
        }
      }
      this.isKey ? codeLogin() : keyLogin()
    },
    upenter() {

    },
    open() {
      this.$nextTick(() => {
        this.$refs.phoneNumber.focusInput()
      })
    }
  },
  created() {

  },
  mounted() {

  }
}
</script>
<style scoped lang='scss'>
 /* @import url(); 引入css类 */
.verification_code_title{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  text-align: left;
  color: #61666d;
  line-height: 22px;
}
.verification_code_label{
  margin: 30px 0 20px;
  display: block;
  span:nth-child(1){
    color: #FF1A2C;
  }
  span:nth-child(2){
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: Bold;
    color: #000;
  }
  span:nth-child(3){
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 400;
    color: #FF1A2C;
    margin-left: 5px;
  }

}
.login_btn{
  width: 100%;
  height: 52px;
  font-size: 16px;
  background: #ff1a2c;
  border-radius: 7px;
  margin-top: 48px;
}
.step_error{
    margin: 0;
    display: flex;
    align-items: center;
    img{
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
    span{
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular;
      color: #ff1a2c;
      line-height: 17px;
    }
  }
  ::v-deep{
  .verification_input{
    width: 387px !important;
    margin: 7px 0 5px;
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 10px;
    display: block;
    .el-input__inner{
      color: #000 !important;
    }
  }
}
</style>
